import React, { ReactNode, useContext, useEffect, useState } from 'react';

import NetworkConcernsContext from '@totem/components/networkConcerns/networkConcernsContext';
import {
  NetworkConcerns,
  NetworkInterfaceConcern,
} from '@totem/components/networkConcerns/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponse } from '@totem/utilities/responseUtilities';
type Props = {
  children?: ReactNode;
};
const NetworkConcernsContainer = ({ children }: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [data, setData] = useState<NetworkConcerns>(null);
  const [networkInterfaces, setNetworkInterfaces] = useState<
    NetworkInterfaceConcern[]
  >([]);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [refreshInterfaces, setRefreshInterfaces] = useState<boolean>(false);
  const [refreshCount, setRefreshCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingInterfaces, setLoadingInterfaces] = useState<boolean>(true);
  useEffect(() => {
    setRefreshData(true);
  }, [userProfile.organization.id]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setLoading(true);

      fetch(`${DEVICES_ENDPOINT}/network/interface/concerns/${refreshCount}`, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => CheckResponse(res))
        .then((res) => res.json())
        .then((result: NetworkConcerns) => {
          setData(result);
        })
        .then(() => {
          setRefreshCount((prevState) => prevState + 1);

          setLoading(false);

          setRefreshInterfaces(true);
        });
    }
  }, [refreshData, getApiToken]);

  useEffect(() => {
    if (refreshInterfaces) {
      setRefreshInterfaces(false);

      setLoadingInterfaces(true);

      fetch(`${DEVICES_ENDPOINT}/network/interfaces/${refreshCount}`, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => CheckResponse(res))
        .then((res) => res.json())
        .then((result: NetworkInterfaceConcern[]) => {
          setNetworkInterfaces(result);
        })
        .then(() => {
          setLoadingInterfaces(false);
        });
    }
  }, [refreshInterfaces, getApiToken]);
  const handleAction = (action: string) => {
    switch (action) {
      case 'refresh':
        setRefreshData(true);
        break;
      default:
        break;
    }
  };
  return (
    <NetworkConcernsContext.Provider
      value={{
        reportData: data,
        interfaceData: networkInterfaces,
        loading,
        loadingInterfaces,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </NetworkConcernsContext.Provider>
  );
};
export default NetworkConcernsContainer;
